export const ADDRESS_BOOK_TEXTS = {
  sectionTitle: 'Annuaire',
  description: 'Destinataires réutilisables pour les notifications d\'alerte.',
  entriesCount: '{count}/{limit} entrées',
  addEntry: 'Ajouter un destinataire',
  addEntryShort: 'Ajouter',
  updateEntry: 'Modifier le destinataire',
  removeEntry: 'Supprimer le destinataire',
  confirmRemove: 'Supprimer ce destinataire de l\'annuaire ?',
  emptyState: 'Aucun destinataire. Ajoutez-en un pour le réutiliser dans vos alertes.',
  loading: 'Chargement de l\'annuaire...',
  nameLabel: 'Nom',
  emailLabel: 'Email',
  phoneLabel: 'Téléphone',
  namePlaceholder: 'Alice Martin',
  emailPlaceholder: 'email@exemple.com',
  phonePlaceholder: '+33612345678',
  errors: {
    ADDRESS_BOOK_ENTRY_NAME_REQUIRED: 'Le nom du destinataire est requis',
    ADDRESS_BOOK_ENTRY_CONTACT_REQUIRED: 'Au moins un email ou un téléphone est requis',
    ADDRESS_BOOK_ENTRY_ID_REQUIRED: 'L\'identifiant du destinataire est requis',
    ADDRESS_BOOK_ORGANIZATION_REQUIRED: 'L\'organisation est requise',
    ADDRESS_BOOK_LIMIT_REACHED: 'Limite de l\'annuaire atteinte',
    ADDRESS_BOOK_ADD_FAILED: 'Échec de l\'ajout du destinataire',
    ADDRESS_BOOK_UPDATE_FAILED: 'Échec de la modification du destinataire',
    ADDRESS_BOOK_REMOVE_FAILED: 'Échec de la suppression du destinataire',
    EMAIL_FORMAT_INVALID: 'Format d\'email invalide',
    PHONE_FORMAT_INVALID: 'Format de téléphone invalide'
  }
} as const;
